import Headroom from 'headroom.js';
import { headerHeight } from '../helpers';

if (!window.dAgency) window.dAgency = {};

$(function () {
  const $siteHeader = $('.site-header');
  const $header = $siteHeader.find('.header__container');
  if ($siteHeader <= 0 || $header.length <= 0)
    return false;

  $('html').css('scroll-padding-top', headerHeight() + 'px');
  $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
  $('#CartPopup').css('top', headerHeight() + 'px');

  $(window).on('resize', function () {
    $('html').css('scroll-padding-top', headerHeight() + 'px');
    $('#PageContainer').css('min-height', 'calc(100vh - ' + headerHeight() + 'px)');
    $('#CartPopup').css('top', headerHeight() + 'px');
  });

  /* ====================== HeadrooomJS ====================== */
  const header = document.querySelector('header.site-header');
  if (header) {
    const options = {
      tolerance: {
        up: 20,
        down: 20
      },
      onPin: function () {
        if (this.elem) {
          const $searchPopup = $header.find('.header__search-popup');
          if ($searchPopup.length > 0) {
            $deskSearchBar.css('top', headerHeight() + 'px');
            $searchPopup.css('top', headerHeight() + 'px');
          }
          if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
            $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
              $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
            });
          }
        }
      },
      onUnpin: function () {
        if (this.elem) {
          const $searchPopup = $header.find('.header__search-popup');
          if ($searchPopup.length > 0) {
            $deskSearchBar.css('top', headerHeight() + 'px');
            $searchPopup.css('top', 'calc(' + headerHeight() + 'px - 34px)');
          }
          if ($desktopMenu.length > 0 && $desktopMenu.hasClass('header__desktop-menu--drawer')) {
            $desktopMenu.find('.header__desktop-menu--drawer__second-level').each(function () {
              $(this).css('height', 'calc(100vh - ' + headerHeight() + 'px)');
            });
          }
        }
      }
    };

    const headroom = new Headroom(header, options);
    headroom.init();
  }

  /* ======================== Header ======================== */
  $header.find('.header__left__newsletter-button').on('click', function () {
    if (typeof (window.dAgency.showNewsletterPopUp) === 'function') window.dAgency.showNewsletterPopUp();
  });

  /* ======================== Mobile Menu ======================== */
  const $mobileMenu = $header.find('.header__mobile-menu');
  if ($mobileMenu.length > 0) {
    const $firstLevel = $mobileMenu.find('.header__mobile-menu--drawer__first-level__title');
    $firstLevel.each(function () {
      const submenu = $(this).data('submenu');
      const $connectedSecondLevel = $mobileMenu.find('.header__mobile-menu--drawer__second-level[data-submenu="' + submenu + '"]');
      $(this).on('click', function (e) {
        if (e.target.getAttribute('href') || $connectedSecondLevel.find('.header__mobile-menu--drawer__second-level__title').length <= 0) return;

        $connectedSecondLevel.addClass('open');
      });
    });

    const $secondLevel = $mobileMenu.find('.header__mobile-menu--drawer__second-level');
    $secondLevel.each(function () {
      const $level = $(this);
      const $close = $(this).find('.header__mobile-menu--drawer__second-level__header__back');
      $close.on('click', function () {
        $level.removeClass('open');
      });

      const $titles = $(this).find('.header__mobile-menu--drawer__second-level__title');
      $titles.each(function () {
        const accordionIndex = $(this).data('accordion-index');
        const $connectedThirdLevel = $level.find('.header__mobile-menu--drawer__third-level[data-accordion-index="' + accordionIndex + '"]');

        $(this).on('click', function (e) {
          if (e.target.getAttribute('href')) return;

          if ($(this).hasClass('open')) {
            const secondLevel = $(this);
            $connectedThirdLevel.slideUp(400, function() {
              secondLevel.removeClass('open');
            });
          } else {
            $(this).addClass('open');
            $connectedThirdLevel.slideDown(400);
          }
        });
      });
    });

    $('.header__mobile-menu--drawer__header__close').on('click', function () {
      $('.header__mobile-menu').removeClass('open');
      $('html').css('overflow', '');
    });

    $('.header__mobile-menu--drawer__second-level__header__close').on('click', function () {
      $('.header__mobile-menu').removeClass('open');
      $('html').css('overflow', '');
    });

    var isMenuOpen = false;
    $header.find('.header__burger-icon').on('click', function () {
      isMenuOpen = !isMenuOpen;
      $mobileMenu.toggleClass('open');
      if (isMenuOpen) {
        $('html').css('overflow', 'hidden');
      }
    });

    $('[data-mobile-menu-opener]').on('click', function (e) {
      if (!e.target.getAttribute('href')) {
        const menuName = $(this).data('mobile-menu-opener');
        $('[data-mobile-menu="' + menuName + '"]').css('transform', 'translate3d(0, 0, 0)');
      }
    });

    $('[data-mobile-menu] .header__mobile-menu__level__title').on('click', function () {
      const $menu = $(this).closest('.header__mobile-menu__level');
      $menu.css('transform', '');
    });
  }

  /* ======================== Desktop Menu ======================== */
  const $desktopMenu = $header.find('.header__desktop-menu');
  const $headerBackdropMenu = $siteHeader.find('.header__backdrop-menu');
  if ($desktopMenu.length > 0) {
    const $dropdownInlineElements = $desktopMenu.find('.header__desktop-menu--dropdown__inline-elements__link');
    $dropdownInlineElements.each(function () {
      $(this).on('mouseenter', function () {

        if($(this).hasClass('__no-children')) {
          return;
        }

        $headerBackdropMenu.addClass('active');
        $(this).addClass('active');
        $header.addClass('force-opacity');
        $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').addClass('open');

        if(!$('.drawer-overlay').hasClass('visible')) {
          $('.drawer-overlay').css('z-index', 3);
          $('.drawer-overlay').addClass('visible');
        }
      });

      $(this).on('mouseleave', function () {
        $headerBackdropMenu.removeClass('active');
        $(this).removeClass('active');
        $header.removeClass('force-opacity');
        $(this).find('.header__desktop-menu--dropdown__dropdown-wrapper').removeClass('open');
        $('.drawer-overlay').removeClass('visible');
        $('.drawer-overlay').css('z-index', 9999);
      });
    });


    $desktopMenu.find('.header__desktop-menu--dropdown__navigation').each(function () {
      const $mediaContainer = $(this).find('.header__desktop-menu--dropdown__navigation__media');
      const $titleWithImages = $(this).find('[data-image-src]');

      $titleWithImages.on('mouseenter', function () {
        const imgSrc = $(this).data('image-src');
        const $img = $mediaContainer.find('[srcset*="' + imgSrc + '"]');

        $mediaContainer.find('.header__desktop-menu--dropdown__navigation__media__img.active').removeClass('active');
        $img.addClass('active');
      });
    });

    const $menuCarousel = $desktopMenu.find('.header__desktop-menu--dropdown__carousel__blocks');
    if ($menuCarousel.length > 0) {
      $menuCarousel.each(function () {
        const slider = $(this)[0];
        if (slider.scrollWidth <= slider.clientWidth) {
          $(this).css('justify-content', 'center');
        } else {
          window.dAgency.initDesktopSlider(slider, 2);
        }
      });
    }
  }
});
